import { render, staticRenderFns } from "./GreetingTitle.vue?vue&type=template&id=bbb8243a&"
import script from "./GreetingTitle.vue?vue&type=script&lang=js&"
export * from "./GreetingTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports